import { render, staticRenderFns } from "./ProductMessagesPanel.vue?vue&type=template&id=11522566&scoped=true"
import script from "./ProductMessagesPanel.vue?vue&type=script&lang=js"
export * from "./ProductMessagesPanel.vue?vue&type=script&lang=js"
import style0 from "./ProductMessagesPanel.vue?vue&type=style&index=0&id=11522566&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11522566",
  null
  
)

export default component.exports